import React, { FC } from 'react';
import './GraphSeriesFilter.css';
import { ChartSerie, DateGranularity, FaCalendar } from '@/Shared';


interface GraphSeriesFilterProps {
	dateGranularity: DateGranularity;
	setDateGranularity: (granularity: DateGranularity) => void;
	chartSeries: ChartSerie[];
	visibleKeys: Set<string>;
	setVisibleKeys: React.Dispatch<React.SetStateAction<Set<string>>>;
	keyToLabelMap: Record<keyof Omit<Record<string, any>, 'date'>, string>,
}

const GraphSeriesFilter: FC<GraphSeriesFilterProps> = ({ chartSeries, dateGranularity, setDateGranularity, visibleKeys, setVisibleKeys, keyToLabelMap }) => {

	const toggleAllSeries = () => {
		const allKeys = chartSeries.map(s => s.key);
		const isFullySelected = allKeys.every(key => visibleKeys.has(key));

		setVisibleKeys(
			isFullySelected ? new Set() : new Set(allKeys)
		);
	};

	const toggleVisibility = (key: string) => {

		setVisibleKeys(prev => {
			const next = new Set(prev);
			next.has(key) ? next.delete(key) : next.add(key);
			return next;
		});
	};

	return (
		<div
			className='GraphSeriesFilter ResultGraph-series fieldset-wrapper' data-testid="GraphSeriesFilter">
			<label className="data-field-label">
				Affichage temporel
				<div className="form-group">
					<div className='Field-wrapper'>
						<div className='field-icon'><FaCalendar /></div>
						<select
							className="select-field"
							value={dateGranularity} onChange={(e) => setDateGranularity(e.target.value as any)}>
							<option value="day">Jour</option>
							<option value="month">Mois</option>
							<option value="year">Année</option>
						</select>
					</div>
				</div>
			</label>
			<label className="data-field-label">
				Séries à afficher
				<div className="date-customized-label">
					<button className="select-all-button button with-icon" type="button" onClick={toggleAllSeries}>
						{visibleKeys.size === chartSeries.length ? 'Tout désélectionner' : 'Tout sélectionner'}
					</button>
				</div>

				<div className="form-group">
					<div className='Field-wrapper checkbox-Field-wrapper'>
						{chartSeries.map((serie) => (
							<label key={serie.key} >
								<input
									type="checkbox"
									checked={visibleKeys.has(serie.key)}
									onChange={() => toggleVisibility(serie.key)}
								/>
								<span style={{ color: serie.color }}>
									{keyToLabelMap[serie.key as keyof typeof keyToLabelMap]}
								</span>
							</label>
						))}
					</div>
				</div>
			</label>

		</div>
	);
}

export default GraphSeriesFilter;
